import { inToolboxItems } from '../../canvas/tooling/ToolboxController';
import { inTool } from '../../canvas/tooling/ToolManager';
import { Package, PackageHost } from '../../Container';
import { inExportAdapter } from '../dataExport/ExportAdapter';
import { inTopicCommands } from './TopicCommands';
import { AssociatedTopicExportAdapter } from './TopicExports';
import { TopicIndex } from './TopicIndex';
import { TopicMechanics } from './TopicMechanics';
import { topicTool } from './TopicTool';
import { topicToolboxItem } from './TopicToolboxItem';

export class TopicPackage implements Package {

    public readonly name = 'TopicPackage';

    public install = (host: PackageHost) => host
        .register(TopicIndex, 'singleton', 'startable')
        .register(TopicMechanics, 'singleton', 'startable')
        .plug(inExportAdapter(AssociatedTopicExportAdapter))
        .plug(inTool(topicTool))
        .plug(inToolboxItems(topicToolboxItem))
        .plug(inTopicCommands());
}
